module.exports = __webpack_public_path__ + "static/media/sample_lmstates.a116aab8.csv";